import {Component, Injector, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AppComponent} from '../../../app.component';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';
import {Meta, Title} from '@angular/platform-browser';
import {ProdutoService} from '../../../core/services/produto.service';
import {PropostaComponent} from '../proposta';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-pagamentos',
    templateUrl: './pagamentos.component.html',
    styleUrls: ['./pagamentos.component.sass']
})
export class PagamentosComponent extends PropostaComponent implements OnInit {

    isAdesao = false;
    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public cepService: CepService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public produtoService: ProdutoService,
        public deviceService: DeviceDetectorService,
        ) {
        super(injector);
    }

    async ngOnInit() {
        this.appComponent.showOverlay();
        await this.inOnInit();
        if (this.getTokenUsuario() === null) {
            this.isAdesao = true;
        }
        this.iframeSrc = this.paginaPagamento + '?p=' + this.propostaStorage.idCotacao;
        setTimeout(() => {
            this.appComponent.hideOverlay();
        }, 1000);
        window.open(this.iframeSrc, '_top');
    }

    showDebitoEmConta(): boolean {
        let result = false;
        if (this.isAdesao) {
            return false;
        }
        const proposta = this.getPropostaParaStorage();
        const usuario = this.getClienteCpf();
        if (usuario) {
            if (usuario.isCliente) {
                result = (proposta) ? proposta.tipoPagamento === 'DB' : false;
            }
            if (usuario.exCliente) {
                result = false;
            }
        }
        return result;
    }
}
